import { compareStr } from '@/plugins/utils'

export default {
  applicationConfigs: (state) => state.configs,
  applicationConfigByYear: (state) => (annee) =>
    state.configs &&
    state.configs.find((model) => model && compareStr(model.getAnnee())(annee)),
  applicationConfigs_pending: (state) => state.configs_pending
}
